const isPlainObject = (value) => value !== null
  && typeof value === "object"
  && !Array.isArray(value)
  && !(value instanceof Blob)
  && !(value instanceof Date);

function append(formData, key, value) {
  if (value === undefined) return;
  if (value === null) {
    formData.append(key, "");
  } else if (value instanceof Blob) {
    formData.append(key, value);
  } else if (Array.isArray(value)) {
    if (value.length === 0) formData.append(`${key}[]`, "");
    value.forEach((item, index) => append(formData, isPlainObject(item) ? `${key}[${index}]` : `${key}[]`, item));
  } else if (isPlainObject(value)) {
    Object.entries(value).forEach(([name, nested]) => append(formData, key ? `${key}[${name}]` : name, nested));
  } else {
    formData.append(key, String(value));
  }
}

export default function toFormData(body) {
  const formData = new FormData();
  append(formData, "", body);
  return formData;
}
